import { FriendSentListCoreProps } from "./type"
import React, { useCallback } from "react"
import { SectionList } from "~/ui/primitives"
import FriendSentListItem from "./components/friend-send-list-item"
import styled from "~/ui/styled"

const Letter = styled.Text`
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.background};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};
  font-size: 13px;
`

export const FriendSentListCore: React.FC<FriendSentListCoreProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  const keyExtractor = useCallback((item) => item.id.toString(), [])
  const renderItem = useCallback(
    ({ item }) => {
      return (
        <FriendSentListItem
          friend={item}
          swipeActionButtonConfigs={swipeActionButtonConfigs}
          onItemClick={onItemClick}
          selecteds={selecteds}
        />
      )
    },
    [selecteds, onItemClick],
  )
  const renderSectionHeader = useCallback(
    ({ section: { title, data } }) => (
      <Letter>{data?.length > 0 ? title + `(${data?.length})` : ""}</Letter>
    ),
    [],
  )

  return (
    <SectionList
      sections={sections}
      keyExtractor={keyExtractor}
      renderSectionHeader={renderSectionHeader}
      renderItem={renderItem}
    />
  )
}
